import { Svg } from 'common/assets'
import { useResolution } from 'common/hooks'
import { GeneralMenu } from 'modules/GeneralMenu'
import { LoadingApps } from 'modules/LoadingApps'
import { Component } from './components'
import { Container, Logo } from './styled'

export const Header = () => {
  const { isMinScreen768, isMinScreen1000 } = useResolution()
  return (
    <>
      <Container>
        <Logo src={Svg.Logo} alt="logo" />
        {isMinScreen1000 && <GeneralMenu />}
        {isMinScreen768 && <LoadingApps />}
        <Component.RightMenu />
      </Container>
    </>
  )
}
